module.exports = __webpack_public_path__ + "static/media/BEREMPA_MENU-normal.9cdf7b00.png";